import React, {Fragment} from 'react';
import {ScrollTopBtn, Seo} from '../components';
import {AboutOne, FeatureOne, FooterOne, HeaderTwo, HeroOne, ServiceOne, TeamOne,} from '../containers';

const HomeOne = ()=> (
  <Fragment>
    <Seo title="Home" />
    <HeaderTwo/>
    <HeroOne/>
    <ServiceOne className="space-top space-extra-bottom"/>
    <div className="background-image" style={{backgroundImage: "url(images/bg/ab-bg-1-1.jpg)"}}>
    <AboutOne className="space-bottom"/>
      <FeatureOne className="space-top space-extra-bottom"/>
    </div>
    <TeamOne className="space-top space-extra-bottom"/>
    <FooterOne/>
    <ScrollTopBtn/>
  </Fragment>
);

export default HomeOne;
